/**
 * @generated SignedSource<<6f27e8bd78b5ea281bfbbe72ca7e5d38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type aroundItemHomeV2QueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"homeAroundMorningStudioPrimaryV2ContentItemContent" | "homeAroundMorningStudioSecondaryV2ContentItemContent" | "homeAroundPrimaryV2ContentItemContent" | "homeAroundSecondaryV2ContentItemContent">;
  };
  readonly " $fragmentType": "aroundItemHomeV2QueueItemsEdge";
}>;
export type aroundItemHomeV2QueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: aroundItemHomeV2QueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"aroundItemHomeV2QueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "aroundItemHomeV2QueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeAroundPrimaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeAroundSecondaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeAroundMorningStudioPrimaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeAroundMorningStudioSecondaryV2ContentItemContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "183a330e23e2264713be036e8021bdfb";

export default node;
